<template>
  <div class="nav" :class="{ 'nav-show': showNav }" id="nav">
    <!-- <img
      src="https://summit-img.geekpark.net/r2020/pc_rebuild2020.svg"
      style="width: 3vh"
      class="ifx"
      @click="handleScroll"
    /> -->
    <div class="navs-container">
      <a class="nav_item_a nav_item_link" href="#if2021-forum-desc">
        <img
          alt
          src="https://summit-img.geekpark.net/if2021/pc/000-导航-论坛介绍.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-论坛介绍.svg;"
          onmouseout="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-论坛介绍.svg';"
        />
      </a>
      <a class="nav_item_a nav_item_link" href="#if2021-kv">
        <img
          alt
          src="https://summit-img.geekpark.net/if2021/pc/000-导航-主题日程.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-主题日程.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-主题日程.svg';"
        />
      </a>
      <a class="nav_item_a nav_item_link" href="#if2021-partner">
        <img
          alt
          src="https://summit-img.geekpark.net/if2021/pc/000-导航-合作伙伴.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-合作伙伴.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-合作伙伴.svg';"
        />
      </a>
      <a class="last_rebuild_wrapper nav_item_a">
        <img
          class="last_rebuild_img"
          alt
          src="https://summit-img.geekpark.net/if2021/pc/000-导航-往届回顾.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-往届回顾.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/if2021/pc/000-导航-往届回顾.svg';"
        />
        <div
          class="last_rebuild_list"
          :class="{
            last_rebuild_list_hide: hideNavLastItem,
          }"
          id="nav_last_rebuild_list"
        >
          <img
            class="year_list_bg"
            alt
            src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-弹窗.svg"
          />
          <div class="year_list_wrapper">
            <a
              class="year_item"
              href="http://ifx.geekpark.net/"
              target="_blank"
            >
              <img
                class="img-year"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2020.svg"
              />
              <img
                class="img-year-bg"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2020-黄色.svg"
              />
            </a>
            <a
              class="year_item"
              href="http://if2019.geekpark.net/"
              target="_blank"
            >
              <img
                class="img-year"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2019.svg"
              />
              <img
                class="img-year-bg"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2019-蓝色.svg"
              />
            </a>
            <a
              class="year_item"
              href="http://if2018.geekpark.net/"
              target="_blank"
            >
              <img
                class="img-year"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2018.svg"
              />
              <img
                class="img-year-bg"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2018-粉色.svg"
              />
            </a>
            <a
              class="year_item"
              href="http://if2017.geekpark.net/"
              target="_blank"
            >
              <img
                class="img-year"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2017.svg"
              />
              <img
                class="img-year-bg"
                src="https://summit-img.geekpark.net/if2021/pc/000-往届回顾-pc-2017-紫色.svg"
              />
            </a>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return { showNav: false, hideNavLastItem: true };
  },
  mounted: function () {
    document.addEventListener("scroll", this.handleScroll, false);
  },
  methods: {
    handleScroll() {
      window.scrollTo({ behavior: "smooth", top: 0 });
    },
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      if (scrollInstance >= 0) {
        this.showNav = true;
        if (this.hideNavLastItem) {
          this.hideNavLastItem = false;
        }
      } else {
        this.showNav = false;
        this.hideNavLastItem = true;
      }
    },
  },
  beforeDestroy: function () {
    document.removeEventListener("scroll", this.handleScroll, false);
  },
};
</script>

<style scoped lang="less">
.nav {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 5vh 0 14vh 0;
  width: 8.5vh;
  height: 100vh;
  position: fixed;
  left: -8.5vh;
  top: 0;
  border-right: 1px solid #9b9b9b;
  background: #fff;
  z-index: 2000;
  transition: all 0.5s;
}

.nav-show {
  left: 0;
}

.ifx:hover {
  cursor: pointer;
}

.navs-container {
  display: flex;
  flex-direction: column;

  .nav_item_a {
    display: block;
    padding: 2vh 0;
    width: 2vh;
    &:hover {
      cursor: pointer;
    }
    &:not(:first-of-type) {
      border-top: 2px solid #ff004f;
    }

    img {
      width: 2vh;
    }
  }
}

.last_rebuild_wrapper {
  position: relative;
  &:hover {
    .last_rebuild_list {
      display: block;
    }
  }
  .last_rebuild_list {
    position: absolute;
    top: -9vh;
    left: 2vh;
    display: none;
    &.last_rebuild_list_hide {
      display: none;
    }
    .year_list_bg {
      height: 28vh;
      width: auto;
    }
    .year_list_wrapper {
      position: absolute;
      top: 0;
      left: 0;
      padding: 1.8vh 2vh 1.8vh 3vh;
      height: 100%;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .year_item {
        display: block;
        margin-bottom: 1vh;
        text-align: center;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          .img-year {
            transform: scale(1.1);
          }
          .img-year-bg{
            visibility: hidden;
          }
        }
      }
      .img-year {
        height: 2.6vh;
        width: auto;
        margin-bottom: -1.2vh;
      }
      .img-year-bg {
        height: 2vh;
        width: auto;
      }
    }
  }
}
</style>
